module.exports = __webpack_public_path__ + "static/media/storePurchase_20_25.369b94d6.png";